// Wraps every localStorage/sessionStorage access. In some browser contexts
// (Safari/Firefox with storage fully blocked, sandboxed iframes, certain
// in-app WebViews) merely READING window.localStorage/sessionStorage throws
// SecurityError "Access is denied for this document" — not just quota or
// write failures. Any unguarded call anywhere in the app is a live crash
// risk (an uncaught throw here reaches the nearest ErrorBoundary and blanks
// the page). This is the one place that risk is allowed to exist.
const safeCall = (fn, fallback) => {
  try {
    return fn();
  } catch (e) {
    return fallback;
  }
};

export const safeLocalStorage = {
  getItem: (key) => safeCall(() => window.localStorage.getItem(key), null),
  setItem: (key, value) => safeCall(() => window.localStorage.setItem(key, value), undefined),
  removeItem: (key) => safeCall(() => window.localStorage.removeItem(key), undefined),
};

export const safeSessionStorage = {
  getItem: (key) => safeCall(() => window.sessionStorage.getItem(key), null),
  setItem: (key, value) => safeCall(() => window.sessionStorage.setItem(key, value), undefined),
  removeItem: (key) => safeCall(() => window.sessionStorage.removeItem(key), undefined),
};

export { safeCall };
